module.exports = __webpack_public_path__ + "img/section-awards-extra.3de4b167.png";